import React, { useState, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../styles/theme';
import Filter from '../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import DateInput from '../../components/DateInput/DateInput';
import Button from '../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
// import { FiFileText } from 'react-icons/fi';
import {
  getWallets
} from '../../store/fetchActions/walletsActions';
// import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
// import { CircularProgress } from '@material-ui/core';
import Table from '../../components/Table/Table';
// import MoneyInput from '../../components/MoneyInput/MoneyInput';
import MaskField from '../../components/MaskField/MaskField';
import Wrapper from '../../components/Wrapper/Wrapper';
// import useCallFilter from '../../utils/hooks/useCallFilter';
// import formatMoney from '../../utils/functions/formatMoneyBRL';
// import formatCPF from '../../utils/functions/formatCPF';
// import formatCNPJ from '../../utils/functions/formatCNPJ';

const { secondaryColor, rbmBlack, mainColor } = theme.colors;

function Wallet() {
  const dispatch = useDispatch();
  
  const {
    walletsData,
    loadingWallets,
    errorWallets,
    paginationWallets,
    errorMessageWallets,
  } = useSelector((state) => state.wallets);

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    CPFCNPJ_CLIENT: '',
    search: '',
    status: '',
    limit: 10,
    page: 1,
    valorMax: 0,
    valorMin: 0,
    tipoTransacao: '',
    modoPagamento: '',
    dataInicial: '',
    dataFinal: '',
    agencia: '',
    conta: '',
  });

  // useCallFilter(filterData, setFilter, reportsFetchAction, 0, 0);

  const { handleSubmit, control } = useForm({});

  const filterTable = (data) => {
    setFilterData(data);
  };

  useEffect(() => {
    dispatch(getWallets());
  }, []);

  // useEffect(() => {
  //   dispatch(reportsFetchAction(filter));
  // }, [filter.page]);

  const arrayCategoryTypes = [
    {
      ID: 0,
      NOME: 'Fulano',
    },
    {
      ID: 1,
      NOME: 'Ciclano',
    },
    {
      ID: 2,
      NOME: 'Beltrano',
    },
  ];

  const arrayTarifas = [
    {
      ID: 0,
      NOME: 'Débito',
    },
    {
      ID: 1,
      NOME: 'Crédito',
    },
  ];

  // const arrayPaymentWays = paymentWays?.map((way) => {
  //   if (way?.NOMECLATURA) {
  //     return { ID: way.CODTIPO, NOME: way.NOMECLATURA };
  //   }
  // });

  // function filterArrayPaymentWays(way) {
  //   if (way) return way;
  // }

  // const newArrayPaymentWays = arrayPaymentWays.filter(filterArrayPaymentWays);

  const header = [
    {
      id: 'data de registro',
      name: 'DATA/HORA',
      align: 'center',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'cpfcnpj',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'agencia',
      name: 'AGÊNCIA',
    },
    {
      id: 'conta',
      name: 'CONTA',
    },
    {
      id: 'gerente',
      name: 'GERENTE',
      align: 'left',
    },
    {
      id: 'gestor',
      name: 'GESTOR',
      align: 'left',
    },
    {
      id: 'executivo',
      name: 'EXECUTIVO',
      align: 'left',
    },
    {
      id: 'tipo taxa',
      name: 'TIPO TAXA',
      align: 'center',
    },
    {
      id: 'valor taxa',
      name: 'VALOR TAXA',
      align: 'right',
    },
  ];

  const pageOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  // const renderDocument = (document) => {
  //   return document
  //     ? document?.length > 11
  //       ? formatCNPJ(document)
  //       : formatCPF(document)
  //     : '-----';
  // };

  const body = walletsData?.map((wallet) => {
    return {
      data: [
        { info: wallet.DATAHORA, align: 'center' },
        { info: wallet.NOME, align: 'left' },
        { info: wallet.CPFCNPJ, align: 'center' },
        { info: wallet.AGENCIA, align: 'center' },
        { info: wallet.CONTA, align: 'center' },
        { info: wallet.GERENTE, align: 'left' },
        { info: wallet.GESTOR, align: 'left' },
        { info: wallet.EXECUTIVO, align: 'left' },
        { info: wallet.TIPOTAXA, align: 'left' },
        { info: wallet.VALORTAXA, align: 'right' },
      ],
    };
  });

  return (
    <Wrapper title="Relatório de Comissão">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'22.042vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <MaskField
                label="Agência"
                name="agencia"
                mask={'9999'}
                width={'22.042vw'}
                control={control}
              />
              <MaskField
                label="Conta"
                name="conta"
                mask="999999999999999"
                width={'22.042vw'}
                control={control}
              />
              <DateInput
                label="Data de Início"
                name={'dataInicial'}
                margin={'0'}
                control={control}
                width={'3.333vw'}
              />
              <DateInput
                label="Data FInal"
                name={'dataFinal'}
                width={'3.333vw'}
                control={control}
              />
            </FirstFilterLine>
            <FirstFilterLine>
              {/* <MoneyInput
                name="valorMin"
                control={control}
                width={'18.042vw'}
                label="Valor Mínimo"
              ></MoneyInput>
              <MoneyInput
                name="valorMax"
                control={control}
                width={'18.042vw'}
                label="Valor Máximo"
              ></MoneyInput> */}
              <SelectOptions
                label="Gerente"
                name={'gerente'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Gestor"
                name={'gestor'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Executivo"
                name={'executivo'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Taxa"
                name={'taxa'}
                width={'18.042vw'}
                control={control}
                options={arrayTarifas}
                initialName={'Todas'}
                initialValue={0}
              />
              <Button
                backgroundColor={secondaryColor}
                width={'16.042vw'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                margin={'0 1.389vw 0 0'}
                roleName="button-buscar-relatorios"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
              {/* <SelectOptions
                label="Tipo Modo de Pagamento"
                name={'modoPagamento'}
                width={'18.042vw'}
                control={control}
                options={newArrayPaymentWays}
                initialName={'Todas'}
                initialValue={0}
              /> */}
            </FirstFilterLine>
            <SecondFilterLine>
              {/* <Button
                backgroundColor={secondaryColor}
                width={'16.042vw'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="button"
                onClick={() => dispatch(reportsExcelFetchAction(filter))}
                margin={'0 1.389vw 0 0'}
                roleName="button-exportar-relatorios"
              >
                <FiFileText className="default-svg" size={'1.181vw'} />
                <span>Exportar</span>
              </Button> */}
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pageOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialName={10}
                initialValue={10}
              />
              <h5>Total de Registros: 0</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingWallets ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingWallets}
            error={errorWallets}
            hasPagination={true}
            filter={filter}
            pagination={paginationWallets}
            setFilter={setFilter}
            errorMessage={errorMessageWallets}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.limit}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default memo(Wallet);
